jQuery(document).ready(function($){
	// Prevent scrolling when mobile menu is open
	$('.navbar-toggler').click( function () {
		$('body').toggleClass('prevent-scroll');
	})
	if ( $(window).width() <= 768 ) {

  	//open menu on click, expand dropdown menu
  	$('#menuToggle').click(function(e){
			$('.navbar-wrapper').toggleClass('active');
			$('.dropdown-menu').addClass('show');
		});

  	$('.nav-link').click(function(){
		$("#navbarNavDropdown").removeClass("show");
	  $("button.navbar-toggler").addClass("collapsed");
	  $("button.navbar-toggler").attr("aria-expanded","false");
	});

  } else {

  	//open menu on hover for desktop
		$('#menuToggle, #navbarNavDropdown').hover(function(){
			$('.navbar-wrapper').addClass('active');
		}, function(){
			$('.navbar-wrapper').removeClass('active');
		});

		//add dropdown menu toggle functionality to down arrow
		$('.dropdown-toggle.nav-link').append('<a href="#" class="ms-3" data-toggle="dropdown" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa-solid fa-chevron-down"></i></a>');
  	
  	$('.dropdown-toggle.nav-link a').click(function(e){
  		$( this ).toggleClass('active');
  		$( this ).parent().siblings('.dropdown-menu').toggleClass('show');
  	})
  }
  // Get the button:
	let mybutton = document.getElementById("btt");

	// When the user scrolls down 20px from the top of the document, show the button
	window.onscroll = function() {scrollFunction()};

	function scrollFunction() {
	  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
	    mybutton.style.display = "block";
	  } else {
	    mybutton.style.display = "none";
	  }
	}

	// When the user clicks on the button, scroll to the top of the document
	$('#btt').click(function(){
	
	  document.body.scrollTop = 0; // For Safari
	  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	});

  // play/pause functionality for full width videos
	$('.block-video-full.new-vid').click (function (e) {
		e.preventDefault(); // <=====================
		var videoBlock = $(this);

		if (videoBlock.hasClass('video-file')) {
			var video = videoBlock;
		} else {
			var video = videoBlock.find('video');
		}
		
		
		video.trigger('play');
		videoBlock.removeClass('new-vid');
		video.attr('controls', true);

	})

	$(document).on('facetwp-loaded', function() {
	    $('.facetwp-facet-search .facetwp-icon').hide();
	    $('.facetwp-facet-search .facetwp-input-wrap').each(function() {
	        if ($(this).find('.facetwp-search-submit').length < 1) {
	            $(this).find('.facetwp-search').after('<button class="facetwp-search-submit" onclick="FWP.refresh()">Search</button>');
	        }
	    });
	});

	 $('.video-slider').slick({
        dots: false,
        arrows: true,
        prevArrow: $('.slick-prev'),
        nextArrow: $('.slick-next'),
        adaptiveHeight: true
    });

    // Play button overlay for HTML5 video
    $('.play-button-overlay-file').on('click', function () {
	    const wrapper = $(this).closest('.video-wrapper');
	    const video = wrapper.find('video').get(0);

	    // Add controls before playing
	    video.setAttribute('controls', true);
	    video.play();
	    
	    $(this).fadeOut();
	});
	$('.video-slider').on('beforeChange', function () {
	    $('.video-player').each(function () {
	        this.pause();
	        this.removeAttribute('controls');
	        this.currentTime = 0; // optional: reset to beginning
	    });

	    // Also show the play buttons again
	    $('.play-button-overlay').fadeIn();
	});
});